import { useState } from "react";
import { countryOptions } from "../../utils/countryOptions";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { fcwdOnly, setFcwdOnly } from "../../utils/data";

function QueryMX() {
  const [countryType, setCountryType] = useState('');
  const [country, setCountry] = useState('');
  const [licenseNumber, setLicenseNumber] = useState('');
  const [validated, setValidated] = useState(false);
  const{source} = useAuth();
  const navigate = useNavigate();
  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.target;

    if((country === 'MX') && (countryType !== 'MX')){
      return;
    }

    if (form.checkValidity() === false) {
        e.stopPropagation(); // prevent submit if invalid
    } else {
      let returnedRecord = false;  
      e.preventDefault();
      console.log(`Country Type: ${countryType}, Country: ${country}, Driver License Number: ${licenseNumber}`);
      if(e.nativeEvent.submitter.value === 'fcwdOnly'){
        setFcwdOnly(true);
      }
      else{
        setFcwdOnly(false);
      }
      navigate(`driverdetails/${country.trim()}/${encodeURIComponent(licenseNumber.trim())}`);
    }
    setValidated(true);
  }


  const handleLicChange = (e) => {
    const v = e.target.value;
    const pattern =  new RegExp("^[a-zA-Z0-9-]*$");
    if(pattern.test(v)){
      setLicenseNumber(v.toUpperCase());
    }
  }

//alert(countryType + " : " + country)

return (
  <div>
    <form className={`needs-validation ${validated ? "was-validated" : ""}`} id="Index-form" noValidate onSubmit={handleSubmit}>
      <div className="row">
        <div className="col-md-2">
          <label className="form-label"><b><span className="text-danger">*</span> Country Type:</b></label>
          <select className="form-control form-select" aria-label=".form-select"
            required
            value={countryType}
            onChange={(e) => {
              setCountryType(e.target.value);
              setCountry(countryOptions[e.target.value][0]?.code || '');
            }}
          >
            <option value="" disabled>-- Select Type --</option>
            <option value="MX">Mexico</option>
            <option value="US">United States Territories</option>
            <option value="OTH">Other Countries</option>
          </select>
          <div className="invalid-feedback">Country Type Required</div>
        </div>
        <div className="col-md-3">
        {(
          <>
            <label className="form-label"><b><span className="text-danger">*</span> Country:</b></label>
            <select className="form-control form-select" aria-label=".form-select-lg example"
              required
              value={country}
              onChange={(e) => setCountry(e.target.value)}
            >{countryType === '' &&
              <option value="" disabled>-- Select Country --</option>}
              {countryType !== '' && countryOptions[countryType].map((opt) => (
                <option key={opt.code} value={opt.code}>
                  {opt.label}
                </option>
              ))}
            </select>
          <div className="invalid-feedback">Country Required</div>
          </>
        )}
        </div>
        <div className="col-md-2">
          <label className="form-label"><b><span className="text-danger">*</span> Driver License Number:</b></label>
          <input type="text" className="form-control text-uppercase"
          id="dlNumber" placeholder="" value = {licenseNumber}
          name="LicenseNumber" maxLength={27}
          style={{textTransform:'uppercase'}}
          onChange={(e) => setLicenseNumber(e.target.value.toUpperCase())} required/>
          <div className="invalid-feedback">Driver License Number Required</div>
        </div>
        {source === 'HelpDesk' ?
        <><div className="col-md-2">
            <button type="submit" className="btn btn-primary" id="button" form='Index-form' style={{ marginTop: '32px' }} disabled={countryType !== "MX"}>Get Driver Data</button>
          </div><div className="col-md-3">
              <button type="submit" className="btn btn-primary" id="button" value={'fcwdOnly'} form='Index-form' style={{ marginTop: '32px' }}>Get Driver Data - FCWD ONLY</button>
            </div></>
              :
              <div className="col-md-3">
              <button type="submit" className="btn btn-primary" id="button" value={countryType === "MX" ? "" : "fcwdOnly"} form='Index-form' style={{alignContent:'end'}}>Submit Driver Query</button>
              </div>
        }
      </div>
    </form>
  </div>
);
}
export default QueryMX;